<template>
      <g-master name="report_role"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="dropdown_report"
                          :selectConfig="{mode:'multiple'}"
                          :label="$t('Reporte') "
                          :formItemConfig="fiOptions"
                          :decorator="['id_report', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="filtroRol"
              >
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
</template>

<script>
  export default {
    data () {
      return {
        filtroRol: {filtro_rol: true},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'role_report',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Código del reporte', dataIndex: 'code_report', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Descripción', dataIndex: 'descripcion', sorter: true}
            ]
          }
        }
      }
    },
    props: ['name'],
    computed: {
      parentData () {
        return {
          role_name: this.name
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/ReportByRol.vue